var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "catalog-banner"
  }, [_c('nuxt-link', {
    attrs: {
      "to": _vm.link
    }
  }, [_c('LazyImg', {
    staticClass: "catalog-banner__img",
    attrs: {
      "img": _vm.src,
      "alt": _vm.alt
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }